import { apiGet, apiPost } from './api';

// Mock Exam Board. The server owns allowance, eligibility and scoring — the
// client only ever renders what it is told.

const P = '/premium/v1/mock-exams';

export const fetchMockConfig = (subject) => apiGet(`${P}/config?subject=${encodeURIComponent(subject || '')}`);
export const fetchMocks = (subject = '') => apiGet(`${P}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`);
export const fetchMock = (mockId) => apiGet(`${P}/${mockId}`);
export const createMock = (payload) => apiPost(P, payload);
export const submitMock = (mockId, payload) => apiPost(`${P}/${mockId}/submit`, payload);
